import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { propOr } from 'ramda';

import { mapIndexed } from 'utils/ramdaAdditions';

export default function withTableRowsData(TableComponent) {
    return class TableRowsData extends Component {
        static propTypes = {
            items: PropTypes.array.isRequired,
            hideGroups: PropTypes.bool,
        };

        render() {
            const { items, hideGroups } = this.props;

            let rowKeys = [];
            const rowClasses = mapIndexed((item, index) => {
                rowKeys[index] = this.getRowKey(item, index);
                return this.getRowClass(item, index, hideGroups);
            }, items);

            return (
                <TableComponent {...this.props} rowClasses={rowClasses} rowKeys={rowKeys}/>
            );
        }

        getRowClass(item, rowIndex, hideGroups) {
            const number = propOr(rowIndex, 'number', item) + 1;
            const even = number && number % 2 === 0;
            const last = rowIndex + 1 === this.props.items.length;

            let rowClass;
            switch (item.groupType) {
                case 'group':
                    rowClass = hideGroups ? 'table-row-hide' : 'table-row-group table-row-group-skyblue';
                    break;
                case 'subgroup':
                    rowClass = 'table-row-group table-row-group-lightblue';
                    break;
                default:
                    rowClass = even ? 'table-row-even' : 'table-row-odd';
            }

            return cx('table-row', rowClass, last ? 'table-row-last' : '');
        }

        getRowKey(item, rowIndex) {
            return (item.groupType) ? rowIndex + 'group' + item[item.groupType] : rowIndex + 'item' + item.id;
        }
    };
}
